import React, {useState} from "react";
import SingleAttachment from "./SingleAttachment";
import TwoAttachments from "./TwoAttachments";
import ThreeAttachments from "./ThreeAttachments";
import FourAttachments from "./FourAttachments";
import FiveOrMoreAttachments from "./FiveOrMoreAttachments";
import { MediaAttachment } from "src/shared/types/src";
import MediaCarouselModal from "../../modals/MediaCarouselModal";

type iProps = { 
    media: MediaAttachment[], 
    openCarousel?: boolean,
    onMediaGroupClick?: () => void
}
const MediaCollageContainer: React.FC<iProps> = ({ media, openCarousel, onMediaGroupClick }) => {

    const [showMediaCarouselModal, setShowMediaCarouselModal] = useState<boolean>(false);

    const handleMediaPress = () => {
        if (openCarousel) {
            toggleMediaCarouselModal()
        }
        onMediaGroupClick && onMediaGroupClick();
    }

    const toggleMediaCarouselModal = () => {
        setShowMediaCarouselModal(!showMediaCarouselModal);
    }
 
    return (
        <>
            <div onClick={handleMediaPress} className="mg-t-8 cursor-pointer">
                {
                    media.length === 1 ? 
                    <SingleAttachment media={media} /> : null
                }
                {
                    media.length === 2 ? 
                    <TwoAttachments media={media} /> : null
                }
                {
                    media.length === 3 ? 
                    <ThreeAttachments media={media} /> : null
                }
                {
                    media.length === 4 ? 
                    <FourAttachments media={media} /> : null
                }
                {
                    media.length >= 5 ?
                    <FiveOrMoreAttachments media={media} /> : null
                }
            </div>
            <MediaCarouselModal
                showMediaCarouselModal={showMediaCarouselModal}
                toggleMediaCarouselModal={toggleMediaCarouselModal}
                media={media || []}
            />
        </>
    )
}

export default MediaCollageContainer;